import * as React from 'react'

function SvgFunArrowMiniRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M14.5 12.5a.475.475 0 01-.163.353l-3.889 3.5a.6.6 0 01-.785 0 .465.465 0 010-.707l3.496-3.146-3.496-3.146a.465.465 0 010-.707.6.6 0 01.785 0l3.89 3.5a.475.475 0 01.162.353" />
    </svg>
  )
}

export default SvgFunArrowMiniRight
